import * as focusModuleTrap from 'focus-trap';

// const createFocusTrap = require('focus-trap'); // https://github.com/davidtheclark/focus-trap/issues/30

const $element = $('.alert-block');
const $button = $('.alert-block__close-button');
const cookieName = $element.data("alert-name");
const cookieValue = $element.data('alert-id');
const exdays = 30;
const $body = $('body');
const $rootPage = $('.root-page');

const focusTrap = focusModuleTrap.createFocusTrap('.alert-block');

const setCookie = (event) => {
    event.preventDefault();
    const d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    const expires = "expires=" + d.toGMTString();
    document.cookie = cookieName + "=" + cookieValue + ";" + expires + ";path=/";
    $body.removeClass('scroll-lock');
    $element.removeClass('alert-block--visible').attr('aria-hidden', 'true');
    $rootPage.attr('aria-hidden', 'false');
    focusTrap.deactivate();
}

const getCookie = (cname) => {
    const name = cname + "=";
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');
    for(var i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
}

const checkCookie = () => {
  if (($element).length > 0) {
    const cookie = getCookie(cookieName);
    if (cookie != cookieValue || $element.data("always-show") === "True") {
        $element.addClass('alert-block--visible').attr('aria-hidden','false');
        $rootPage.attr('aria-hidden', 'true');
        $body.addClass('scroll-lock');
        focusTrap.activate();
    }
  }
}

const events = () => {
    checkCookie();
    $button.on('click', setCookie);
}

const init = () => {
  events();
}

export default init;